export default __webpack_public_path__ + "static/media/room-geleia-real-main.112ba845.jpg";